<template>
    <div>
        <DxForm :form-data="formData" :col-count="2"  validation-group="customerData">
            <DxSimpleItem  v-if="type != 'birthday'" data-field="startTime" :col-span="1" editor-type="dxDateBox" :editor-options="{type: 'datetime', displayFormat: 'yyyy-MM-dd'}" >
                <DxLabel text="内容发布日期" />
            </DxSimpleItem>
            <DxSimpleItem data-field="UID"   :col-span="2" >
                <DxLabel text="选择营销活动" />
                <template #default>
                    <div>
                        <DxDropDownBox ref="gridBoxValue" v-model:value="gridBoxValue" :defer-rendering="false" :show-clear-button="true"
                                       :data-source="gridDataSource" display-expr="marketingName" value-expr="id" placeholder="请选择营销活动">
                            <template #content="{ data }">
                                <DxDataGrid :data-source="gridDataSource"
                                            :hover-state-enabled="true"
                                            :selection="{ mode: 'single' }"
                                            @selection-changed="selectionChanged">
                                    <DxColumn data-field="marketingName" caption="营销名称" data-type="string" :hiding-priority="3"/>
                                    <dx-paging :page-size="10" />
                                    <dx-pager  :allowed-page-sizes="[10, 20, 50, 100,200]" :show-page-size-selector="true"
                                               :show-info="true" :show-borders="true" :show-navigation-buttons="true"/>
                                    <DxHeaderFilter :visible="true" :allow-search="true"/>
                                    <DxFilterRow :visible="true"/>
                                </DxDataGrid>
                            </template>
                        </DxDropDownBox>
                    </div>
                </template>
            </DxSimpleItem>
        </DxForm>
        <div>
            <!--                        <div>{{modeMap}}</div>-->
            <DxForm  :col-count="2" :form-data="formData2"  >
                <DxGroupItem  v-for="(mode,index) in modeMap" :key="index" >
                    <DxSimpleItem :data-field="mode.itemValue">
                        <DxLabel :text="mode.itemName" />
                    </DxSimpleItem>
                </DxGroupItem>
            </DxForm>

        </div>
        <div align="center">
            <DxButton @click="submitFrom" class="my_submit">发送</DxButton>
            <DxButton  type="danger" :use-submit-behavior="true" @click="$emit('close')" text="关闭"/>
        </div>
    </div>
</template>

<script>
    import CustomStore from "devextreme/data/custom_store";

    export default {
        name: "ContentPageAdd",
        data(){
            return{
                type:"list",
                formData:{},
                formData2:{},
                DataSource:{},
                modeMap:[],
                gridDataSource: [],
                gridBoxValue: [],
                selectionChanged: (data) => {
                    //console.log(data.selectedRowsData[0])
                this.gridBoxValue=[]
                for(var i=0;i<data.selectedRowsData.length;i++){
                    this.gridBoxValue[i] = data.selectedRowsData[i].id
                    this.DataSource.messagePublicId=data.selectedRowsData[i].id
                    this.DataSource.messagePublicName=data.selectedRowsData[i].marketingName
                    this.DataSource.modeId=data.selectedRowsData[i].modeId
                    this.DataSource.wxId=data.selectedRowsData[i].appId
                }
                if(this.gridBoxValue.length>0){
                    this.changeModeltBox(data.selectedRowsData[0])
                }
                }
            }
        },
        created() {
            this.getData()
        },
        methods:{
            getData(){
                this.$http.get_marketing_list({"type" : 0}).then(res => {
                    if(res.status == "success"){
                        this.gridDataSource= this.makeAsyncDataSource(res.data);
                    }

                })
            },
            makeAsyncDataSource(json) {
                return new CustomStore({
                    loadMode: 'raw',
                    key: 'id',
                    load() {
                        return json;
                    },
                });
            },
            changeModeltBox(e){
                //获取模板详情
                this.$http.get_model_info({"appId":e.wxId,"modelId":e.modeId}).then(res=> {
                    this.modeMap = []
                    if (res.status == "success") {
                        let modelMap = res.data[0].content
                        this.transFormMap(modelMap)
                    }
                })
            },

            transFormMap(modelMap){
                for (let key in modelMap) {
                    let temp = {
                        "itemValue": modelMap[key],
                        "itemName": key==" "?modelMap[key]:key
                    }
                    this.modeMap.push(temp)
                }

            },
            submitFrom(){
                var date = new Date(this.formData.startTime)
                this.DataSource.sendDate= date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
                this.DataSource.content=this.formData2
                // this.DataSource.content=this.DataSource.content.substring(1, this.DataSource.content.length - 1);
                // this.DataSource.content = this.DataSource.content.substring(0, this.DataSource.content.length - 1);
                this.$http.ContentAdd(this.DataSource).then(res =>{
                    if(res.status == "success"){
                        this.$emit('close')
                        this.$emit('refresh')
                        this.$notify({type:'success',message:res.msg, position: "top center" });
                    }else {
                        this.$notify({type:'error',message:res.msg, position: "top center",width: 1,});
                    }
                })

            },
        }
    }
</script>

<style scoped>

</style>